import { Skeleton, Stack } from "@mui/material";

import { InlineSlot } from "@/components/banners/placements/InlineSlot";
import MostPopularPlansInline from "@/components/cards/MostPopularPlansInline";
import CanceledProductView from "./CanceledProductView";
import InactiveProductView from "./InactiveProductView";
import ProductOverviewCard from "./ProductOverviewCard";
import ProductTabs from "./ProductTabs";
import { DashboardProduct } from "./useDashboardProducts";
import { DashboardProductSelection } from "./useDashboardProductSelection";

function ProductContent({ product }: { product: DashboardProduct }) {
  switch (product.status) {
    case "active":
      return (
        <>
          <ProductOverviewCard product={product} />
          <InlineSlot slot="dashboardUnderPlan" />
          {product.type === "free" ? (
            <MostPopularPlansInline title="Most Popular Paid Plans" />
          ) : null}
        </>
      );
    case "cancelled":
      return <CanceledProductView product={product} />;
    case "inactive":
      return <InactiveProductView product={product} />;
  }
}

/**
 * The product-tab dashboard (r-1776): dashboard content is split by
 * product, driven by `useDashboardProductSelection`.
 */
export default function DashboardProductNavigation({
  selection,
}: {
  selection: DashboardProductSelection;
}) {
  const { products, isLoading, selectedType, selectedProduct, setSelected } =
    selection;

  if (isLoading && !products.length) {
    return (
      <Stack spacing={3} width="100%">
        <Skeleton variant="rounded" height={72} />
        <Skeleton variant="rounded" height={280} />
      </Stack>
    );
  }

  return (
    <Stack spacing={3} width="100%">
      <ProductTabs
        products={products}
        selectedType={selectedType}
        onSelect={setSelected}
      />
      {selectedProduct ? <ProductContent product={selectedProduct} /> : null}
    </Stack>
  );
}
